import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { NonAisParent } from '../';
import { NonAisStudent } from '../';

// Import Setting Service and User, Credential Model
import { ApiService, SettingService } from '../../core/services';

@Injectable()
export class RegisterService {
    private activationUrl = '/activations';
    private holParentUrl = '/hol/parent';
    private holStudenttUrl = '/hol/student';
    private holPasswordUrl = '/hol/parent/password';
    private apiUrl = '';

    constructor (
        private settingService: SettingService,
        private apiService: ApiService
    ) {
        this.apiUrl = this.settingService.getSetting('api_service_domain');
    }

    postActivationEmail(role:string, email: string): Observable<any> {
        const requestUrl = this.apiUrl + this.activationUrl;
        const body = JSON.stringify({
                        'role': role,
                        'email': email
                     });
        
        return this.apiService.post(requestUrl, body);
    }

    verifyActivationToken(token: string): Observable<any> {
        const requestUrl = this.apiUrl + this.activationUrl + "/" + token;

        return this.apiService.get(requestUrl);
    }

    // verifyActivationRecovery(recovery: string): Observable<any> {
    //     const requestUrl = this.apiUrl + this.holPasswordUrl;

    //     return this.apiService.get(requestUrl);
    // }

    setPasswordWithActivationToken(token: string, password: string): Observable<any> {
        const requestUrl = this.apiUrl + this.activationUrl + "/" + token;
        // TODO: update body content
        const body = JSON.stringify({password});

        return this.apiService.patch(requestUrl, body);
    }

    setPasswordWithActivationRecovery(recovery: string, email: string, password: string): Observable<any> {
        
        const requestUrl = this.apiUrl + this.holPasswordUrl;
        // TODO: update body content
        const body = JSON.stringify({
            'email': email, 
            'recovery': recovery, 
            'password': password
        });

        return this.apiService.post(requestUrl, body)
        
    }
    postNoneAisAccount(nonAisParent: NonAisParent) {
        const requestUrl = this.apiUrl + this.holParentUrl + "/register";
        const body = JSON.stringify(nonAisParent);
        return this.apiService.post(requestUrl, body);
    }

    postNonAisStudent(nonAisStudent: NonAisStudent) {
        const requestUrl = this.apiUrl + this.holStudenttUrl;
        const body = JSON.stringify(nonAisStudent);
        return this.apiService.post(requestUrl, body)
    }

    updateParent(nonAisParent: NonAisParent) {
        const requestUrl = this.apiUrl + this.holParentUrl;

        const body = JSON.stringify(nonAisParent);

        return this.apiService.patch(requestUrl, body)
    }
}


// WEBPACK FOOTER //
// ./src/common/modules/user/services/RegisterService.ts